module.exports = __webpack_public_path__ + "img/142-2c950b.png";